// @spec POL-STR-030
// Procedures library index route

import { createFileRoute } from '@tanstack/react-router';

import { ProceduresLibraryPage } from '@/features/procedures/components/ProceduresLibraryPage';

export const Route = createFileRoute('/_authenticated/procedures/')({
  component: ProceduresLibraryPage,
});
